/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Title_PartialInputs */

const cs_import_done_title_partial = /** @type {(inputs: Import_Done_Title_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import dokončen s problémy`)
};

const en_import_done_title_partial = /** @type {(inputs: Import_Done_Title_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import finished with issues`)
};

/**
* | output |
* | --- |
* | "Import finished with issues" |
*
* @param {Import_Done_Title_PartialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_title_partial = /** @type {((inputs?: Import_Done_Title_PartialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Title_PartialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_title_partial(inputs)
	return cs_import_done_title_partial(inputs)
});